function testimonialsCarousel() {
	var owl3 = $(".testimonialsCarousel .owlCarousel");
	owl3.owlCarousel({
		loop:false,
		responsive:{
			0:{items:1},
			640:{items:2},
			1280:{items:3},
		},
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
	});
	$(".testimonialsCarousel .owlControl .right").click(function() {
		owl3.trigger('next.owl.carousel');
	});
	$(".testimonialsCarousel .owlControl .left").click(function() {
		owl3.trigger("prev.owl.carousel");
	});
}